<div class="outer-wrapper"><ng-content></ng-content></div>
